export const SCHEDULE_EVENT_TYPES = {
  EDUCATIONAL: 'EDUCATIONAL',
  ASSIGNMENT: 'ASSIGNMENT',
  CASE: 'CASE',
};

export const ATTENDANCE_MODES = {
  IN_PERSON: 'IN_PERSON',
  VIRTUAL: 'VIRTUAL',
  HYBRID: 'HYBRID',
};

/** Mirrors the backend's `CHECK_IN_ATTENDANCE_MODES` (`checkIn.model.js`) — the subset of `ATTENDANCE_MODES` a check-in record may carry. */
export const CHECK_IN_ATTENDANCE_MODES = [ATTENDANCE_MODES.IN_PERSON, ATTENDANCE_MODES.VIRTUAL];

// Virtual and hybrid events carry a join link; on-site events don't. Single
// source of truth for both the link's visibility and whether it's persisted.
export const attendanceModeUsesWebLink = mode => mode !== ATTENDANCE_MODES.IN_PERSON;

// The link value to persist for a given format: trimmed for virtual/hybrid,
// dropped to '' for on-site so a hidden link never lingers on the record.
export const effectiveWebLink = (mode, webLink) =>
  attendanceModeUsesWebLink(mode) ? (webLink || '').trim() : '';

export const EVENT_GROUP_TYPES = {
  EDUCATIONAL: 'EDUCATIONAL',
  ASSIGNMENTS: 'ASSIGNMENTS',
};

// Mirrors the backend CADENCES.
export const CADENCES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  BI_WEEKLY: 'BI_WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
};

// Form-only "Does not repeat" sentinel; never sent to the backend.
export const RECURRENCE_NONE = 'NONE';

export const RECURRING_EDIT_SCOPE = {
  SINGLE: 'single',
  GROUP: 'group',
};

// Analytics dimensions for Schedule events — shared vocabulary sent to Mixpanel.
export const SCHEDULE_ANALYTICS_TAB = {
  EVENTS: 'events',
  REPORTS: 'reports',
};

export const SCHEDULE_ANALYTICS_VIEW_TYPE = {
  BY_PERSON: 'by_person',
  BY_EVENT: 'by_event',
};

export const SCHEDULE_DATE_FILTERS = {
  ALL: 'all',
  UPCOMING: 'upcoming',
};

export const SCHEDULE_ANALYTICS_FILTER_TYPE = {
  HOSTED_BY: 'hostedBy',
  DATES: 'dates',
};

export const SCHEDULE_REPORT_EXPORT_TYPE = {
  PERSON: 'person',
  EVENT: 'event',
  PEOPLE_BULK: 'people-bulk',
  EVENTS_BULK: 'events-bulk',
  EVENT_ATTENDEES: 'event-attendees',
};

// Educational-events list window & paging.
export const EDUCATIONAL_EVENTS_PAST_DAYS = 365;
export const EDUCATIONAL_EVENTS_PAST_PAGE_SIZE = 200;
export const EDUCATIONAL_EVENTS_FUTURE_PAGE_SIZE = 100;

// Entry surfaces (schedule screen, home widget) show only today + nearest
// upcoming — bound the future fetch instead of pulling every occurrence.
export const SCHEDULE_ENTRY_FUTURE_PAGE_SIZE = 50;

export const CHECK_IN_METHODS = {
  QR: 'QR',
  MANUAL: 'MANUAL',
  SELF_ATTESTATION: 'SELF_ATTESTATION',
};

export const QR_TYPES = {
  ROTATING: 'ROTATING',
  STATIC: 'STATIC',
};

/** Minutes offered by the "check-in opens" dropdown (before start). */
export const CHECK_IN_OPENS_BEFORE_START_OPTIONS = [0, 15, 30, 60, 120, 360, 720];

/** Minutes offered by the "check-in closes" dropdown (after end). */
export const CHECK_IN_CLOSES_AFTER_END_OPTIONS = [0, 30, 60, 120, 1440, 2880, 5760];

export const DEFAULT_CHECK_IN_WINDOW = {
  checkInOpensBeforeStartMinutes: 0,
  checkInClosesAfterEndMinutes: 0,
};

export const CHECK_IN_WINDOW_SIDES = Object.freeze({
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
});

// BE-returned error.code values for POST /check-ins. Values stay lowercase
// snake_case as the BE emits them (see schedule attendance tech design).
// The codeless errors (401/403/404/400 without a `code`) are caught via the
// fallback in useQrCheckIn.
export const CHECK_IN_ERROR_CODES = {
  SESSION_CLOSED: 'session_closed',
  INVALID_CODE: 'invalid_code',
  ALREADY_CHECKED_IN: 'already_checked_in',
  EVENT_TYPE_MISMATCH: 'event_type_mismatch',
  SELF_ATTESTATION_DISABLED: 'self_attestation_disabled',
};

export const NO_OPEN_CHECK_IN_SESSION_MESSAGE_PREFIX = 'No open check-in session for event';
